export const isGiftCardSku = (sku: string) =>
  sku === 'e_gift_card_001' || sku === 'gift_card_001'

export const getCartItemStock = (item: { sku: string; quantity?: number; stock?: number; product?: any }) => {
  // Gift cards are issued on purchase and do not consume catalog stock.
  if (isGiftCardSku(item.sku)) return Math.max(5, item.quantity || 1)
  const simple = item.product?.simpleProducts?.find(product => product.sku === item.sku)
  return item.stock ?? simple?.stock ?? 0
}
